module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70518/img/content-remix-post-publish/content-remix-ja.png"